import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'MaybeIcon',
  props: {
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (typeof _ctx.value != 'string')
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: _ctx.value.icon
        }, null, 8, ["icon"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.value), 1))
  ]))
}
}

})